module.exports = __webpack_public_path__ + "static/img/DSC02494.f7adc7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02494.jpg
// module id = ymrV
// module chunks = 0